module.exports = __webpack_public_path__ + "static/media/DSCF0153-rWwoiYgs.5f36080e.JPG";